import { createTheme } from '@mui/material/styles';
export default createTheme({
  palette: {
    primary: { main: '#0d766e', dark: '#095c56', contrastText: '#ffffff' },
    secondary: { main: '#183b4a' },
    background: { default: '#f3f6f7', paper: '#ffffff' },
    text: { primary: '#18313c', secondary: '#627680' },
    divider: '#e3eaed',
  },
  typography: {
    fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif',
    fontSize: 13,
    body1: { fontSize: '0.8125rem' },
    body2: { fontSize: '0.75rem' },
    button: { textTransform: 'none', fontWeight: 600, fontSize: '0.8125rem' },
    h5: { fontSize: '1.125rem', fontWeight: 700, letterSpacing: '-.025em' },
    h6: { fontSize: '1rem', fontWeight: 700, letterSpacing: '-.02em' },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: { defaultProps: { disableElevation: true, size: 'small' }, styleOverrides: { root: { minHeight: 34, borderRadius: 8, padding: '6px 12px', '@media (pointer:coarse)': { minHeight: 44 } } } },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 12 } } },
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiFormControl: { defaultProps: { size: 'small' } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 8, backgroundColor: '#fff', fontSize: 13 }, input: { padding: '9px 12px' } } },
    MuiTable: { defaultProps: { size: 'small' } },
    MuiTableCell: { styleOverrides: { head: { backgroundColor: '#edf4f4', color: '#526870', fontWeight: 700, fontSize: 11 }, root: { padding: '8px 10px', borderColor: '#e8eef0', fontSize: 12 } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 14, '@media (max-width:600px)': { margin: 8, width: 'calc(100% - 16px)', maxHeight: 'calc(100dvh - 16px)' } } } },
    MuiDialogTitle: { styleOverrides: { root: { padding: '12px 16px', fontSize: 16 } } },
    MuiDialogContent: { styleOverrides: { root: { padding: 16 } } },
    MuiDialogActions: { styleOverrides: { root: { padding: '10px 16px', borderTop: '1px solid #e3eaed' } } },
    MuiMenu: { styleOverrides: { paper: { border: '1px solid #e3eaed', boxShadow: '0 12px 36px rgba(16,44,54,.14)' } } },
    MuiMenuItem: { styleOverrides: { root: { minHeight: 36, fontSize: 13, '@media (pointer:coarse)': { minHeight: 44 } } } },
    MuiChip: { defaultProps: { size: 'small' }, styleOverrides: { root: { borderRadius: 6, fontWeight: 600, fontSize: 11 } } },
    MuiTabs: { styleOverrides: { root: { minHeight: 38 } } },
    MuiTab: { styleOverrides: { root: { minHeight: 38, textTransform: 'none', padding: '8px 14px', fontSize: 13 } } },
    MuiIconButton: { defaultProps: { size: 'small' }, styleOverrides: { root: { '@media (pointer:coarse)': { minWidth: 44, minHeight: 44 } } } },
  },
});
